{
  "version": 1,
  "asset_id": "ea7d5248-8045-4bbd-978d-60413377ec38",
  "project_id": "f7b0049a-604b-4310-83a1-b58bfd5bd64c",
  "url": "/__l5e/assets-v1/ea7d5248-8045-4bbd-978d-60413377ec38/verqo-icon.png",
  "r2_key": "a/v1/f7b0049a-604b-4310-83a1-b58bfd5bd64c/ea7d5248-8045-4bbd-978d-60413377ec38/verqo-icon.png",
  "original_filename": "verqo-icon.png",
  "size": 676529,
  "content_type": "image/png",
  "created_at": "2026-07-11T09:28:51Z"
}
